
angular.module('app.controllers.search', ['ngLodash'])
  .controller('GlobalSearchController', ['$scope', 'lodash', 'SearchService',
      function ($scope, lodash, SearchService) {

    $scope.data = {};
    $scope.options = { 'max': 10 };

	  $scope.loadMore = function() {
      $scope.options.append = true;
      $scope.options.start += $scope.options.max;
      return SearchService.findPages($scope.options, $scope.data);
	  };

	  var params = window.location.search.slice(1).split('&');
	  var result = {};
	  params.forEach(function(pair) {
      pair = pair.split('=');
      var val = decodeURIComponent(pair[1] || '');
      if (val !== '' && !isNaN(Number(val))) {
        val = parseInt(val);
      }
      result[pair[0]] = val;
	  });

    lodash.assign($scope.options, result);
    SearchService.findPages($scope.options, $scope.data);
	}])

  .controller('VideoSearchController', ['$sce','$scope', function ($sce, $scope) {
    $scope.videos = [];
    $scope.MAXRESULTS = 9;
    $scope.MAXCHARACTERS = 200;

    $scope._showVideos = function($pageToken) {
      $.getJSON('https://www.googleapis.com/youtube/v3/playlistItems?part=contentDetails%2Csnippet&pageToken=' + 
          $pageToken + '&playlistId=UUlG9cM3AUZHwAU21y421J5A&maxResults=' + $scope.MAXRESULTS + 
          '&fields=items(contentDetails%2FvideoId%2Csnippet%2Ftitle%2Csnippet%2Fdescription)%2CnextPageToken%2CprevPageToken%2CtokenPagination&key=AIzaSyB45VJVHLly_l8hfc1DzsDgFcVJJDiiJBo',
          function(response) {
        if (response.prevPageToken !== null) {
          $scope.prevPage = response.prevPageToken;
        } else {
          $scope.prevPage = null;
        }
        if (response.nextPageToken !== null) {
          $scope.nextPage = response.nextPageToken;
        } else {
          $scope.nextPage = null;
        }
        //$scope.videos = []; // Replaced for "Load More"
        for(var i=0; i<response.items.length; i++) { 
          var vidDescr = response.items[i].snippet.description;
          if (vidDescr.length > $scope.MAXCHARACTERS){
            vidDescr = vidDescr.substr(0,$scope.MAXCHARACTERS) + "...";
          }
          $scope.videos.push({
              "title": response.items[i].snippet.title, 
              "descr": vidDescr, 
              "vidid": response.items[i].contentDetails.videoId,
              "vidUrl": $sce.trustAsResourceUrl("//www.youtube.com/embed/" + response.items[i].contentDetails.videoId + "?controls=1&amp;modestbranding=1&amp;showinfo=0&amp;fs=1&amp;rel=0&amp;enablejsapi=1&amp;origin=https://www.swgas.com")          
          });
        }
        if(response.items.length < $scope.MAXRESULTS){
          $scope.nextPage = null;
        }

        $scope.$apply();
      });
    };
    $scope._showVideos("");
	}]);